import moment from 'moment';
import React, {useEffect, useState} from 'react';
import {View, Text, StyleSheet, TouchableOpacity, FlatList} from 'react-native';
import {Color, globalFontStyle} from '../../../assets';

const eventDetailsRow1 = [
  {
    title: 'Pool Size',
    key: 'volume',
  },
  {
    title: 'Total Participants',
    key: 'total_participation',
  },
];

const eventDetailsRow2 = [
  {
    title: 'Close Time',
    key: 'end_time',
  },
  {
    title: 'Start Time',
    key: 'start_time',
  },
];
const ClubEventDetail = ({clubEventDetails}) => {
  return (
    <View style={{marginBottom: 30}}>
      <Text style={styles.clubEventTitle}>About the event</Text>
      <View style={{flexDirection: 'row', justifyContent: 'space-between'}}>
        {eventDetailsRow1.map((item, index) => {
          return (
            <View>
              <Text
                style={[
                  globalFontStyle.appFontSmallText10,
                  index === 1 ? {textAlign: 'right'} : {},
                ]}>
                {item.title}
              </Text>
              <Text
                style={[
                  globalFontStyle.appFontSubHeading,
                  index === 1 ? {textAlign: 'right'} : {},
                ]}>
                {clubEventDetails?.[item.key]}
              </Text>
            </View>
          );
        })}
      </View>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginTop: 15,
        }}>
        {eventDetailsRow2.map((item, index) => {
          return (
            <View>
              <Text
                style={[
                  globalFontStyle.appFontSmallText10,
                  index === 1 ? {textAlign: 'right'} : {},
                ]}>
                {' '}
                {item.title}
              </Text>
              <Text style={globalFontStyle.appFontSubHeading}>
                {moment
                  .utc(clubEventDetails?.[item.key])
                  .local()
                  .format('MMM DD, YYYY hh:mm a')}
              </Text>
            </View>
          );
        })}
      </View>
    </View>
  );
};

export default ClubEventDetail;

const styles = StyleSheet.create({
  clubEventTitle: {
    ...globalFontStyle.appFontHeading,
    marginBottom: 20,
    color: Color.black,
  },
});
